import React, { useMemo } from 'react';
import { Carousel } from 'antd';
import {
  ThunderboltOutlined, HddOutlined, CloseCircleOutlined,
  DollarOutlined, WarningOutlined,
} from '@ant-design/icons';

const PER_SLIDE = 3;

const iconFor = (type) => {
  const map = {
    danger: { icon: <CloseCircleOutlined />, cls: 'danger' },
    warning: { icon: <ThunderboltOutlined />, cls: 'warning' },
    info: { icon: <HddOutlined />, cls: 'info' },
    success: { icon: <DollarOutlined />, cls: 'success' },
  };
  return map[type] || { icon: <WarningOutlined />, cls: 'warning' };
};

const AlertsCarousel = ({ alerts }) => {
  const slides = useMemo(() => {
    const items = alerts.length
      ? alerts
      : [{ key: 'ok', type: 'success', title: 'Todo en orden', detail: 'No hay alertas activas en este momento.' }];
    const chunks = [];
    for (let i = 0; i < items.length; i += PER_SLIDE) {
      chunks.push(items.slice(i, i + PER_SLIDE));
    }
    return chunks;
  }, [alerts]);

  return (
    <div className="yzen-card yzen-alerts-wrap">
      <h3 className="yzen-card-title">
        <WarningOutlined /> Alertas del sistema
      </h3>
      <Carousel
        className="yzen-carousel-dots yzen-card-carousel"
        dots
        infinite={false}
        autoplay={slides.length > 1}
        autoplaySpeed={6000}
        adaptiveHeight
      >
        {slides.map((group, idx) => (
          <div key={idx} className="yzen-carousel-slide">
            {group.map((a) => {
              const { icon, cls } = iconFor(a.type);
              return (
                <div key={a.key} className="yzen-alert-item">
                  <div className={`yzen-alert-icon ${cls}`}>{icon}</div>
                  <div>
                    <div className="yzen-alert-title">{a.title}</div>
                    <div className="yzen-alert-desc">{a.detail}</div>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default AlertsCarousel;
